namespace advisorop.components.advisor {
    

    class AdvisorSearchBoxController {
        selectedItem: domains.ISearchInvestorHouseholdResults;
        isAdvisor: boolean;
        isServicer: boolean;
        noNavigate: boolean = false;
        noNavigateCallback: any = undefined;

        
        static $inject = ["advisorService", "servicerService", "identityService", "generalService", "$filter", "$rootRouter"];
        constructor(private advisorService: services.AdvisorService, private servicerService: services.ServicerService, private identityService: services.IdentityService, private generalService: services.GeneralService , public $filter, public $rootRouter) {
        }
        
        searchItems(searchTerm: string): ng.IPromise<Array<{}>> {
            var service = this.isAdvisor ? this.advisorService : (this.isServicer ? this.servicerService : this.advisorService);
            return service.searchInvestorsHouseholds(searchTerm).then((response) => {
                return response.data;
            });
        }

        onSelectItem(item, model, label, event): void {
            if (this.noNavigate) {
                if (this.noNavigateCallback != undefined && this.noNavigateCallback != null) {
                    if (item.entityType == 0) {
                        this.noNavigateCallback({ type: "investor", id: this.selectedItem.id });
                    } else if (item.entityType == 1) {
                        this.noNavigateCallback({ type: "household", id: this.selectedItem.id });
                    }
                }
            } else {
                //console.log("YES... NAVIGATING");
                if (this.isServicer) {
                    this.servicerService.getAdvisor(item.advisorId)
                        .then(resp => {
                            var advisor = resp.data;
                            if (item.entityType == 0) {
                                this.goToInvestorDashboard(advisor);
                            } else if (item.entityType == 1) {
                                this.goToHouseholdDashboard(advisor);
                            }
                        }, err => {
                            this.generalService.showError(err);
                        })
                        .finally(() => {
                            this.selectedItem = null;
                        });
                }
                else {
                    if (item.entityType == 0) {
                        this.$rootRouter.navigate(['Advisor', 'AdvisorInvestorDashboard', { investorId: item.id }]);
                    }
                    else {
                        this.$rootRouter.navigate(['Advisor', 'AdvisorHouseholdDashboard', { householdId: item.id }]);
                    }
                    this.selectedItem = null;
                }
            }
        }

        okToImpersonateAdvisor(advisor: domains.IAdvisor): boolean {
            if (advisor.systemLogin && advisor.systemLogin.loginStatus != 1)
                return false;
            else
                return true;
        }

        private impersonateAdvisorAt(advisor: domains.IAdvisor, confirmationMsg: string, landingPage: string): void {
            if (this.okToImpersonateAdvisor(advisor)) {
                if (window.confirm(confirmationMsg)) {
                    // authenticate servicer as advisor 
                    this.identityService.impersonateUser(advisor.systemLogin.username)
                        .then(response => {
                            // clear localstorage
                            localStorage.clear();
                            // redirect page to advisor dashboard
                            window.location.href = landingPage;
                        }).catch(err => toastr.error(`Error ${err.status} ${err.data}`))
                }
            } else {
                if (advisor.systemLogin.loginStatus != 1) {
                    toastr.warning("You can only impersonate users with ACTIVE Login Status.");
                } else {
                    toastr.warning("You can not impersonate this user.");
                }
            }
        }

        goToHouseholdDashboard(advisor: domains.IAdvisor): void {
            this.impersonateAdvisorAt(advisor, `Impersonate ${advisor.fullName} and go to the "${this.selectedItem.name}" household dashboard?`, `/advisor/advisorhouseholddashboard/${this.selectedItem.id}`);
        }

        goToInvestorDashboard(advisor: domains.IAdvisor): void {
            this.impersonateAdvisorAt(advisor, `Impersonate ${advisor.fullName} and go to the "${this.selectedItem.name}" investor dashboard?`, `/advisor/advisorinvestordashboard/${this.selectedItem.id}`);
        }

        async getAdvisors(id: number) {
            var resp = await this.servicerService.getAdvisors(id)
                .catch(err => this.generalService.showError(err));
            return resp;
        };
      
        $onInit(): void {        
        }

        $routerOnActivate(next, previous) {
            //console.log(next);
        }

        $onChanges(evt) {
            //console.log(evt);
        }
    }

    //title 3 types indvidual , joint more than one, custodian 
    class AdvisorSearchBox implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.controller = AdvisorSearchBoxController;
            this.controllerAs = "vm";
            this.bindings = {
                isAdvisor: "<",
                isServicer: "<",
                noNavigate: "<",
                noNavigateCallback: "&"
            };
            this.templateUrl = "spa/advisor-module/components/advisor-search-box.html";
        }

    }
    angular.module(Constants.APP).component("advisorSearchBox", new AdvisorSearchBox());


}